// Google Drive 資料夾連結
// 2026-07：改為「連結導向雲端硬碟」——網站不再抓 Drive 圖片組版，
// 只組出資料夾網址讓使用者自己點開（權限完全交給 Drive 的分享設定管）。

export function driveFolderUrl(folderId) {
  if (!folderId) return null;
  return `https://drive.google.com/drive/folders/${folderId}`;
}
